/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTutorsIndexRouteImport } from './routes/_authenticated/tutors/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedStudentsIndexRouteImport } from './routes/_authenticated/students/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedQuestionLibIndexRouteImport } from './routes/_authenticated/question-lib/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedClassesIndexRouteImport } from './routes/_authenticated/classes/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedTutorsCreateRouteImport } from './routes/_authenticated/tutors/create'
import { Route as AuthenticatedStudentsCreateRouteImport } from './routes/_authenticated/students/create'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedQuestionLibQuesiontionLibIdRouteImport } from './routes/_authenticated/question-lib/$quesiontionLibId'
import { Route as AuthenticatedMarkingListParticipantRouteImport } from './routes/_authenticated/marking/list-participant'
import { Route as AuthenticatedTutorsEditTutorIdRouteImport } from './routes/_authenticated/tutors/edit.$tutorId'
import { Route as AuthenticatedCreatePracticeTestModuleIdClassIdRouteImport } from './routes/_authenticated/create-practice-test/$moduleId.$classId'
import { Route as AuthenticatedCreateMockExamModuleIdClassIdRouteImport } from './routes/_authenticated/create-mock-exam/$moduleId.$classId'
import { Route as AuthenticatedStudentsDetailStudentIdClassIdRouteImport } from './routes/_authenticated/students/detail.$studentId.$classId'
import { Route as AuthenticatedClassesDetailClassIdModuleIdRouteImport } from './routes/_authenticated/classes/detail.$classId.$moduleId'
import { Route as AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRouteImport } from './routes/_authenticated/create-practice-test/detail.$ptId.$moduleId.$classId'
import { Route as AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRouteImport } from './routes/_authenticated/create-mock-exam/detail.$ptId.$moduleId.$classId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/clerk/_authenticated',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/clerk/(auth)',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTutorsIndexRoute =
  AuthenticatedTutorsIndexRouteImport.update({
    id: '/tutors/',
    path: '/tutors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStudentsIndexRoute =
  AuthenticatedStudentsIndexRouteImport.update({
    id: '/students/',
    path: '/students/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedQuestionLibIndexRoute =
  AuthenticatedQuestionLibIndexRouteImport.update({
    id: '/question-lib/',
    path: '/question-lib/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClassesIndexRoute =
  AuthenticatedClassesIndexRouteImport.update({
    id: '/classes/',
    path: '/classes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedTutorsCreateRoute =
  AuthenticatedTutorsCreateRouteImport.update({
    id: '/tutors/create',
    path: '/tutors/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStudentsCreateRoute =
  AuthenticatedStudentsCreateRouteImport.update({
    id: '/students/create',
    path: '/students/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedQuestionLibQuesiontionLibIdRoute =
  AuthenticatedQuestionLibQuesiontionLibIdRouteImport.update({
    id: '/question-lib/$quesiontionLibId',
    path: '/question-lib/$quesiontionLibId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarkingListParticipantRoute =
  AuthenticatedMarkingListParticipantRouteImport.update({
    id: '/marking/list-participant',
    path: '/marking/list-participant',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTutorsEditTutorIdRoute =
  AuthenticatedTutorsEditTutorIdRouteImport.update({
    id: '/tutors/edit/$tutorId',
    path: '/tutors/edit/$tutorId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreatePracticeTestModuleIdClassIdRoute =
  AuthenticatedCreatePracticeTestModuleIdClassIdRouteImport.update({
    id: '/create-practice-test/$moduleId/$classId',
    path: '/create-practice-test/$moduleId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreateMockExamModuleIdClassIdRoute =
  AuthenticatedCreateMockExamModuleIdClassIdRouteImport.update({
    id: '/create-mock-exam/$moduleId/$classId',
    path: '/create-mock-exam/$moduleId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStudentsDetailStudentIdClassIdRoute =
  AuthenticatedStudentsDetailStudentIdClassIdRouteImport.update({
    id: '/students/detail/$studentId/$classId',
    path: '/students/detail/$studentId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClassesDetailClassIdModuleIdRoute =
  AuthenticatedClassesDetailClassIdModuleIdRouteImport.update({
    id: '/classes/detail/$classId/$moduleId',
    path: '/classes/detail/$classId/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute =
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRouteImport.update({
    id: '/create-practice-test/detail/$ptId/$moduleId/$classId',
    path: '/create-practice-test/detail/$ptId/$moduleId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute =
  AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRouteImport.update({
    id: '/create-mock-exam/detail/$ptId/$moduleId/$classId',
    path: '/create-mock-exam/detail/$ptId/$moduleId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/marking/list-participant': typeof AuthenticatedMarkingListParticipantRoute
  '/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/students/create': typeof AuthenticatedStudentsCreateRoute
  '/tutors/create': typeof AuthenticatedTutorsCreateRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/classes/': typeof AuthenticatedClassesIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/question-lib/': typeof AuthenticatedQuestionLibIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/students/': typeof AuthenticatedStudentsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/tutors/': typeof AuthenticatedTutorsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/create-mock-exam/$moduleId/$classId': typeof AuthenticatedCreateMockExamModuleIdClassIdRoute
  '/create-practice-test/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestModuleIdClassIdRoute
  '/tutors/edit/$tutorId': typeof AuthenticatedTutorsEditTutorIdRoute
  '/classes/detail/$classId/$moduleId': typeof AuthenticatedClassesDetailClassIdModuleIdRoute
  '/students/detail/$studentId/$classId': typeof AuthenticatedStudentsDetailStudentIdClassIdRoute
  '/create-mock-exam/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute
  '/create-practice-test/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/marking/list-participant': typeof AuthenticatedMarkingListParticipantRoute
  '/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/students/create': typeof AuthenticatedStudentsCreateRoute
  '/tutors/create': typeof AuthenticatedTutorsCreateRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/classes': typeof AuthenticatedClassesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/question-lib': typeof AuthenticatedQuestionLibIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/students': typeof AuthenticatedStudentsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/tutors': typeof AuthenticatedTutorsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/create-mock-exam/$moduleId/$classId': typeof AuthenticatedCreateMockExamModuleIdClassIdRoute
  '/create-practice-test/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestModuleIdClassIdRoute
  '/tutors/edit/$tutorId': typeof AuthenticatedTutorsEditTutorIdRoute
  '/classes/detail/$classId/$moduleId': typeof AuthenticatedClassesDetailClassIdModuleIdRoute
  '/students/detail/$studentId/$classId': typeof AuthenticatedStudentsDetailStudentIdClassIdRoute
  '/create-mock-exam/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute
  '/create-practice-test/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/marking/list-participant': typeof AuthenticatedMarkingListParticipantRoute
  '/_authenticated/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/students/create': typeof AuthenticatedStudentsCreateRoute
  '/_authenticated/tutors/create': typeof AuthenticatedTutorsCreateRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/classes/': typeof AuthenticatedClassesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/question-lib/': typeof AuthenticatedQuestionLibIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/students/': typeof AuthenticatedStudentsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/tutors/': typeof AuthenticatedTutorsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/create-mock-exam/$moduleId/$classId': typeof AuthenticatedCreateMockExamModuleIdClassIdRoute
  '/_authenticated/create-practice-test/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestModuleIdClassIdRoute
  '/_authenticated/tutors/edit/$tutorId': typeof AuthenticatedTutorsEditTutorIdRoute
  '/_authenticated/classes/detail/$classId/$moduleId': typeof AuthenticatedClassesDetailClassIdModuleIdRoute
  '/_authenticated/students/detail/$studentId/$classId': typeof AuthenticatedStudentsDetailStudentIdClassIdRoute
  '/_authenticated/create-mock-exam/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute
  '/_authenticated/create-practice-test/detail/$ptId/$moduleId/$classId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/clerk'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/marking/list-participant'
    | '/question-lib/$quesiontionLibId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/students/create'
    | '/tutors/create'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/classes/'
    | '/help-center/'
    | '/question-lib/'
    | '/settings/'
    | '/students/'
    | '/tasks/'
    | '/tutors/'
    | '/users/'
    | '/create-mock-exam/$moduleId/$classId'
    | '/create-practice-test/$moduleId/$classId'
    | '/tutors/edit/$tutorId'
    | '/classes/detail/$classId/$moduleId'
    | '/students/detail/$studentId/$classId'
    | '/create-mock-exam/detail/$ptId/$moduleId/$classId'
    | '/create-practice-test/detail/$ptId/$moduleId/$classId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/marking/list-participant'
    | '/question-lib/$quesiontionLibId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/students/create'
    | '/tutors/create'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/classes'
    | '/help-center'
    | '/question-lib'
    | '/settings'
    | '/students'
    | '/tasks'
    | '/tutors'
    | '/users'
    | '/create-mock-exam/$moduleId/$classId'
    | '/create-practice-test/$moduleId/$classId'
    | '/tutors/edit/$tutorId'
    | '/classes/detail/$classId/$moduleId'
    | '/students/detail/$studentId/$classId'
    | '/create-mock-exam/detail/$ptId/$moduleId/$classId'
    | '/create-practice-test/detail/$ptId/$moduleId/$classId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/marking/list-participant'
    | '/_authenticated/question-lib/$quesiontionLibId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/students/create'
    | '/_authenticated/tutors/create'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/classes/'
    | '/_authenticated/help-center/'
    | '/_authenticated/question-lib/'
    | '/_authenticated/settings/'
    | '/_authenticated/students/'
    | '/_authenticated/tasks/'
    | '/_authenticated/tutors/'
    | '/_authenticated/users/'
    | '/_authenticated/create-mock-exam/$moduleId/$classId'
    | '/_authenticated/create-practice-test/$moduleId/$classId'
    | '/_authenticated/tutors/edit/$tutorId'
    | '/_authenticated/classes/detail/$classId/$moduleId'
    | '/_authenticated/students/detail/$studentId/$classId'
    | '/_authenticated/create-mock-exam/detail/$ptId/$moduleId/$classId'
    | '/_authenticated/create-practice-test/detail/$ptId/$moduleId/$classId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tutors/': {
      id: '/_authenticated/tutors/'
      path: '/tutors'
      fullPath: '/tutors/'
      preLoaderRoute: typeof AuthenticatedTutorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/students/': {
      id: '/_authenticated/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof AuthenticatedStudentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/question-lib/': {
      id: '/_authenticated/question-lib/'
      path: '/question-lib'
      fullPath: '/question-lib/'
      preLoaderRoute: typeof AuthenticatedQuestionLibIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/classes/': {
      id: '/_authenticated/classes/'
      path: '/classes'
      fullPath: '/classes/'
      preLoaderRoute: typeof AuthenticatedClassesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/tutors/create': {
      id: '/_authenticated/tutors/create'
      path: '/tutors/create'
      fullPath: '/tutors/create'
      preLoaderRoute: typeof AuthenticatedTutorsCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/students/create': {
      id: '/_authenticated/students/create'
      path: '/students/create'
      fullPath: '/students/create'
      preLoaderRoute: typeof AuthenticatedStudentsCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/question-lib/$quesiontionLibId': {
      id: '/_authenticated/question-lib/$quesiontionLibId'
      path: '/question-lib/$quesiontionLibId'
      fullPath: '/question-lib/$quesiontionLibId'
      preLoaderRoute: typeof AuthenticatedQuestionLibQuesiontionLibIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marking/list-participant': {
      id: '/_authenticated/marking/list-participant'
      path: '/marking/list-participant'
      fullPath: '/marking/list-participant'
      preLoaderRoute: typeof AuthenticatedMarkingListParticipantRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tutors/edit/$tutorId': {
      id: '/_authenticated/tutors/edit/$tutorId'
      path: '/tutors/edit/$tutorId'
      fullPath: '/tutors/edit/$tutorId'
      preLoaderRoute: typeof AuthenticatedTutorsEditTutorIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-practice-test/$moduleId/$classId': {
      id: '/_authenticated/create-practice-test/$moduleId/$classId'
      path: '/create-practice-test/$moduleId/$classId'
      fullPath: '/create-practice-test/$moduleId/$classId'
      preLoaderRoute: typeof AuthenticatedCreatePracticeTestModuleIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-mock-exam/$moduleId/$classId': {
      id: '/_authenticated/create-mock-exam/$moduleId/$classId'
      path: '/create-mock-exam/$moduleId/$classId'
      fullPath: '/create-mock-exam/$moduleId/$classId'
      preLoaderRoute: typeof AuthenticatedCreateMockExamModuleIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/students/detail/$studentId/$classId': {
      id: '/_authenticated/students/detail/$studentId/$classId'
      path: '/students/detail/$studentId/$classId'
      fullPath: '/students/detail/$studentId/$classId'
      preLoaderRoute: typeof AuthenticatedStudentsDetailStudentIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/classes/detail/$classId/$moduleId': {
      id: '/_authenticated/classes/detail/$classId/$moduleId'
      path: '/classes/detail/$classId/$moduleId'
      fullPath: '/classes/detail/$classId/$moduleId'
      preLoaderRoute: typeof AuthenticatedClassesDetailClassIdModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-practice-test/detail/$ptId/$moduleId/$classId': {
      id: '/_authenticated/create-practice-test/detail/$ptId/$moduleId/$classId'
      path: '/create-practice-test/detail/$ptId/$moduleId/$classId'
      fullPath: '/create-practice-test/detail/$ptId/$moduleId/$classId'
      preLoaderRoute: typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-mock-exam/detail/$ptId/$moduleId/$classId': {
      id: '/_authenticated/create-mock-exam/detail/$ptId/$moduleId/$classId'
      path: '/create-mock-exam/detail/$ptId/$moduleId/$classId'
      fullPath: '/create-mock-exam/detail/$ptId/$moduleId/$classId'
      preLoaderRoute: typeof AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedMarkingListParticipantRoute: typeof AuthenticatedMarkingListParticipantRoute
  AuthenticatedQuestionLibQuesiontionLibIdRoute: typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  AuthenticatedStudentsCreateRoute: typeof AuthenticatedStudentsCreateRoute
  AuthenticatedTutorsCreateRoute: typeof AuthenticatedTutorsCreateRoute
  AuthenticatedClassesIndexRoute: typeof AuthenticatedClassesIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedQuestionLibIndexRoute: typeof AuthenticatedQuestionLibIndexRoute
  AuthenticatedStudentsIndexRoute: typeof AuthenticatedStudentsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTutorsIndexRoute: typeof AuthenticatedTutorsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedCreateMockExamModuleIdClassIdRoute: typeof AuthenticatedCreateMockExamModuleIdClassIdRoute
  AuthenticatedCreatePracticeTestModuleIdClassIdRoute: typeof AuthenticatedCreatePracticeTestModuleIdClassIdRoute
  AuthenticatedTutorsEditTutorIdRoute: typeof AuthenticatedTutorsEditTutorIdRoute
  AuthenticatedClassesDetailClassIdModuleIdRoute: typeof AuthenticatedClassesDetailClassIdModuleIdRoute
  AuthenticatedStudentsDetailStudentIdClassIdRoute: typeof AuthenticatedStudentsDetailStudentIdClassIdRoute
  AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute: typeof AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute: typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedMarkingListParticipantRoute:
    AuthenticatedMarkingListParticipantRoute,
  AuthenticatedQuestionLibQuesiontionLibIdRoute:
    AuthenticatedQuestionLibQuesiontionLibIdRoute,
  AuthenticatedStudentsCreateRoute: AuthenticatedStudentsCreateRoute,
  AuthenticatedTutorsCreateRoute: AuthenticatedTutorsCreateRoute,
  AuthenticatedClassesIndexRoute: AuthenticatedClassesIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedQuestionLibIndexRoute: AuthenticatedQuestionLibIndexRoute,
  AuthenticatedStudentsIndexRoute: AuthenticatedStudentsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTutorsIndexRoute: AuthenticatedTutorsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedCreateMockExamModuleIdClassIdRoute:
    AuthenticatedCreateMockExamModuleIdClassIdRoute,
  AuthenticatedCreatePracticeTestModuleIdClassIdRoute:
    AuthenticatedCreatePracticeTestModuleIdClassIdRoute,
  AuthenticatedTutorsEditTutorIdRoute: AuthenticatedTutorsEditTutorIdRoute,
  AuthenticatedClassesDetailClassIdModuleIdRoute:
    AuthenticatedClassesDetailClassIdModuleIdRoute,
  AuthenticatedStudentsDetailStudentIdClassIdRoute:
    AuthenticatedStudentsDetailStudentIdClassIdRoute,
  AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute:
    AuthenticatedCreateMockExamDetailPtIdModuleIdClassIdRoute,
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute:
    AuthenticatedCreatePracticeTestDetailPtIdModuleIdClassIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
